// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--OQcI7","close":"_4f720283bf--close--DBdCi","left":"_4f720283bf--left--jZOuO","title":"_4f720283bf--title--AReIW","text":"_4f720283bf--text--kUKQB"};